import { LoadingOutlined } from '@ant-design/icons';
import { Spin, Tooltip } from 'antd';
import styled from 'styled-components';

import { CheckSvg } from '../../../assets/icons';
import { CloudSvg } from '../../../assets/icons/CloudSvg';
import theme from '../../../assets/theme';
import { useBreakPoint } from '../../../hooks/useBreakPoint';
import { IconWrapper } from '../IconWrapper';

const SaveCloud = ({
  isSavingTemplate,
  isSavingTemplateSuccess,
  isSavingTemplateError,
  color = theme.colors.white,
}: {
  isSavingTemplate: boolean;
  isSavingTemplateSuccess: boolean;
  isSavingTemplateError: boolean;
  color?: string;
}) => {
  const isDesktop = useBreakPoint(600);
  const size = isDesktop ? '32px' : '24px';
  const title = isSavingTemplate
    ? 'Saving'
    : isSavingTemplateSuccess
    ? 'All changes saved. Click to restore a previous version'
    : isSavingTemplateError
    ? 'Error saving' // TODO  provide more info if errors occur
    : '';
  return (
    <Tooltip title={title} mouseEnterDelay={1}>
      <SaveCloudContainer height={size} width={size} color={color}>
        <CloudSvg />
        {isSavingTemplateSuccess && !isSavingTemplate && !isSavingTemplateError && (
          <OverriddenIconWrapper height="14px" width="14px" color={color}>
            <CheckSvg />
          </OverriddenIconWrapper>
        )}
        {isSavingTemplate && (
          <OverriddenIconWrapper height="12px" width="12px" color={color}>
            <Spin
              style={{ height: '10px', width: '10px', fontSize: 10, lineHeight: '14px' }}
              indicator={
                <LoadingOutlined
                  style={{
                    width: 10,
                    height: 10,
                    color,
                    fontSize: 10,
                    lineHeight: '14px',
                  }}
                />
              }
            />
          </OverriddenIconWrapper>
        )}
        {isSavingTemplateError && (
          <OverriddenIconWrapper height="14px" width="14px" color={color}>
            <div>!</div>
          </OverriddenIconWrapper>
        )}
      </SaveCloudContainer>
    </Tooltip>
  );
};

export default SaveCloud;

const SaveCloudContainer = styled(IconWrapper)`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0px 8px;

  @media (max-width: 600px) {
    padding: 0px;
  }
`;

const OverriddenIconWrapper = styled(IconWrapper)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
`;
